import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Label } from '../Common/UI';

const ProductAnatomySection = () => {
    const sectionRef = useRef(null);
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.defaultMuted = true;
            videoRef.current.muted = true;
            videoRef.current.play().catch(err => {
                console.warn("Video autoplay blocked or failed:", err);
            });
        }
    }, []);

    return (
        <section id="product-hub" className="pt-10 pb-24 md:py-24 lg:py-32 bg-[#FCFBF9] overflow-hidden" ref={sectionRef}>
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">

                <div className="relative max-w-[1200px] mx-auto mb-10 md:mb-14 px-4 md:px-0 mt-8 md:mt-0">
                    <div className="text-center mb-4 md:mb-6">
                        <Label className="text-[#f2663b] flex items-center justify-center gap-2 mb-3 font-bold uppercase tracking-[0.1em] whitespace-nowrap">
                            High flow rates, no more waiting.
                        </Label>
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tighter text-[#2A2422] leading-[1.1] md:leading-[1.05]">
                            Clean water, minerals, {' '}
                            <span className="relative inline-block group cursor-help underline decoration-dashed decoration-stone-300 underline-offset-[6px] hover:decoration-[#f2663b] transition-colors">
                                molecular hydrogen
                                <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-4 w-64 sm:w-80 p-4 bg-white border border-stone-200 text-sm text-stone-600 rounded-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50 text-center shadow-xl font-sans font-normal normal-case tracking-normal leading-relaxed translate-y-1 group-hover:translate-y-0">
                                    Natural supplement, primarily used for fighting oxidative stress and regulating oxidants.
                                    <br />
                                    <Link to="/science" className="text-[#f2663b] font-semibold hover:underline mt-2 inline-block">Read more in our Science page.</Link>
                                    <span className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-white drop-shadow-[0_1px_0_rgba(0,0,0,0.05)]"></span>
                                </span>
                            </span>
                        </h2>
                        </div>

                        <div className="max-w-4xl mx-auto mb-5 md:mb-6 px-6 text-center text-balance">
                            <div className="space-y-1">
                                <p className="text-lg md:text-xl text-stone-600 font-medium leading-tight max-w-2xl mx-auto">
                                    3X RO's flow rate means you fill your cups, bottles, and pots quickly.
                                </p>
                                <p className="text-lg md:text-xl text-stone-600 font-medium leading-tight max-w-3xl mx-auto">
                                    No waiting for clean water after emptying your pitcher or RO tank.
                                </p>
                            </div>
                            <p className="text-xl md:text-2xl lg:text-3xl font-semibold tracking-tight text-[#2A2422] leading-[1.1] mt-8 md:whitespace-nowrap">
                                With Viven, you don't need to manage your filtered water anymore.
                            </p>
                        </div>

                        <div className="max-w-4xl mx-auto rounded-[2rem] md:rounded-[2.5rem] overflow-hidden safari-rounded-fix shadow-2xl relative border border-stone-200/50">
                        <video
                            ref={videoRef}
                            autoPlay
                            muted
                            loop
                            playsInline
                            className="w-full h-auto block"
                        >
                            <source src="https://res.cloudinary.com/dsyxtnpgm/video/upload/q_auto,f_auto/v1771687911/Video_Project_7_cye3pk.mp4" type="video/mp4" />
                        </video>
                        {/* NSF Logo Overlay */}
                        <div className="absolute bottom-4 left-4 md:bottom-8 md:left-8 z-20">
                            <img
                                src="https://res.cloudinary.com/dsyxtnpgm/image/upload/v1771587494/NSF_International_logo.svg_1_srmspw.webp"
                                alt="NSF Certified"
                                className="h-8 md:h-12 w-auto object-contain grayscale opacity-80 mix-blend-screen transition-all duration-500"
                            />
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default ProductAnatomySection;
